module.exports = __webpack_public_path__ + "media/application/images/2024/title-1500-f907c327a2f05aa56eca0cf21ce28b97.png";